import * as React from "react";

function SvgIcDdArrowUp(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.578 13.021l5.05-4.511c.76-.68 1.989-.68 2.749 0l5.05 4.511c1.228 1.098.35 2.979-1.385 2.979h-10.1c-1.734 0-2.592-1.881-1.364-2.979z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcDdArrowUp;
